module.exports = __webpack_public_path__ + "static/media/epic-banner.ade51d5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epic-banner.jpg
// module id = 1226
// module chunks = 0